<section>
    <div *ngIf="userFromStorage" class="alert alert-light d-flex flex-column align-items-center gap-5 mt=5 mb-5">
        <span class="mt-5 fs-6">
            You already have an account with us
        </span>
        <div class="d-flex flex-row gap-5 mb-5">
            <button routerLink="/home" class="btn btn-wide btn-primary fw-bold">
                Homepage
            </button>
            <button routerLink="/account" class="btn btn-wide btn-primary fw-bold">
                My Account
            </button>
        </div>
    </div>
    <ng-container *ngIf="!userFromStorage">
        <form #ngForm="ngForm" [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off" novalidate
            class="customer-account-row">
            <div formGroupName="contact">
                <div class="row mb-4">
                    <div class="col-12 col-lg-4 col-xl-3">
                        <div class="fs-6 text-primary">Personal Details</div>
                    </div>
                    <div class="col-12 col-lg-8 col-xl-9">
                        <div class="mb-3 fs-16 position-relative">
                            <input [ngClass]="{
                                    'is-invalid':
                                        form.controls['contact'].get('firstname').invalid &&
                                        form.controls['contact'].get('firstname').touched
                                }" type="text" class="form-control border-0" name="firstname"
                                formControlName="firstname" placeholder="First name">
                            <span class="text-danger required-input">*</span>
                            <div class="invalid-feedback mt-1 error-show">
                                <i class="fa fa-exclamation-circle"></i>
                                Please enter your first name
                            </div>
                        </div>
                        <div class="mb-3 fs-6 position-relative">
                            <input [ngClass]="{
                                    'is-invalid':
                                        form.controls['contact'].get('surname').invalid &&
                                        form.controls['contact'].get('surname').touched
                                }" type="text" class="form-control border-0" name="surname" formControlName="surname"
                                placeholder="Last name">
                            <span class="text-danger required-input">*</span>
                            <div class="invalid-feedback mt-1 error-show">
                                <i class="fa fa-exclamation-circle"></i>
                                Please enter your surname
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mb-4">
                    <div class="col-12 col-lg-4 col-xl-3">
                        <div class="fs-6 text-primary">Contact Details</div>
                    </div>
                    <div class="col-12 col-lg-8 col-xl-9">
                        <div class="mb-3 fs-6 position-relative">
                            <input [ngClass]="{
                                    'is-invalid':
                                        form.controls['contact'].get('email').invalid &&
                                        form.controls['contact'].get('email').touched
                                }" (blur)="checkReferralCode()" type="email" class="form-control border-0" name="email"
                                formControlName="email" placeholder="Email">
                            <span class="text-danger required-input">*</span>
                            <div *ngIf="!isEmailExist()" class="invalid-feedback mt-1 error-show">
                                <i class="fa fa-exclamation-circle"></i>
                                Please enter your email address
                            </div>


                            <div *ngIf="isEmailExist()" class="invalid-feedback mt-1 error-show">
                                <i class="fa fa-exclamation-circle"></i>
                                User already created with this email
                            </div>
                        </div>
                        <ng-container *ngIf="referralCode !== ''">
                            <div *ngIf="!validReferralCode" class="alert alert-danger mb-3">
                                The email address entered is not valid for this referral code
                            </div>
                        </ng-container>
                        <div class="mb-3 position-relative"></div>
                        <div class="mb-3 fs-6 position-relative">
                            <ys-phone-input formControlName="mobile" cssClass="border-0"></ys-phone-input>
                            <span class="text-danger required-input">*</span>
                            <div class="invalid-feedback mt-1 error-show">
                                <i class="fa fa-exclamation-circle"></i>
                                Please provide a valid mobile number
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mb-4">
                <div class="col-12 col-lg-4 col-xl-3">
                    <div class="text-primary">Create Password</div>
                </div>
                <div class="col-12 col-lg-8 col-xl-9">
                    <div class="mb-3 fs-6 position-relative">
                        <input [ngClass]="{
                                'is-invalid': form.controls.password.invalid && form.controls.password.dirty
                            }" type="password" autocomplete="new-password" class="form-control border-0"
                            formControlName="password" placeholder="Password">
                        <span class="text-danger required-input">*</span>
                        <div class="password-check">
                            <span>
                                <i *ngIf="form.controls['password'].hasError('required')"
                                    class="fa fa-exclamation-circle"></i>
                                <i *ngIf="!form.controls['password'].hasError('required')" [ngClass]="
                                        form.controls['password'].hasError('minlength')
                                            ? 'fa fa-times-circle'
                                            : 'fa fa-check-circle'
                                    " aria-hidden="true">
                                </i>
                                Minimum of 8 characters
                                <br>
                            </span>
                            <span>
                                <i *ngIf="form.controls['password'].hasError('required')"
                                    class="fa fa-exclamation-circle"></i>
                                <i *ngIf="!form.controls['password'].hasError('required')" [ngClass]="
                                        form.controls['password'].hasError('hasNumber')
                                            ? 'fa fa-times-circle'
                                            : 'fa fa-check-circle'
                                    " aria-hidden="true">
                                </i>
                                At least 1 number (0-9)
                                <br>
                            </span>
                            <span>
                                <i *ngIf="form.controls['password'].hasError('required')"
                                    class="fa fa-exclamation-circle"></i>
                                <i *ngIf="!form.controls['password'].hasError('required')" [ngClass]="
                                        form.controls['password'].hasError('hasCapitalCase')
                                            ? 'fa fa-times-circle'
                                            : 'fa fa-check-circle'
                                    " aria-hidden="true">
                                </i>
                                At least 1 uppercase (A-Z)
                                <br>
                            </span>
                            <span>
                                <i *ngIf="form.controls['password'].hasError('required')"
                                    class="fa fa-exclamation-circle"></i>
                                <i *ngIf="!form.controls['password'].hasError('required')" [ngClass]="
                                        form.controls['password'].hasError('hasSmallCase')
                                            ? 'fa fa-times-circle'
                                            : 'fa fa-check-circle'
                                    " aria-hidden="true">
                                </i>
                                At least 1 lowercase (a-z)
                                <br>
                            </span>
                            <span>
                                <i *ngIf="form.controls['password'].hasError('required')"
                                    class="fa fa-exclamation-circle"></i>
                                <i *ngIf="!form.controls['password'].hasError('required')" [ngClass]="
                                        form.controls['password'].hasError('hasSpecialCharacters')
                                            ? 'fa fa-times-circle'
                                            : 'fa fa-check-circle'
                                    " aria-hidden="true">
                                </i>
                                At least 1 special character
                                <br>
                            </span>
                        </div>
                    </div>
                    <div class="mb-3 fs-6 position-relative">
                        <input [ngClass]="{
                                'is-invalid':
                                    (form.controls.passwordConfirm.invalid && form.controls.passwordConfirm.dirty) ||
                                    (form.hasError('passwordNotMatch') && form.controls.passwordConfirm.dirty)
                            }" type="password" autocomplete="new-password" class="form-control border-0"
                            formControlName="passwordConfirm" placeholder="Confirm password">
                        <span class="text-danger required-input">*</span>
                        <div class="invalid-feedback mt-1 error-show">
                            <i class="fa fa-exclamation-circle"></i>
                            Passwords do not match
                        </div>
                    </div>
                </div>
            </div>
            <div class="mb-3">
                <input [checked]="user.marketing" (click)="toggleValue('marketing')" id="marketing" type="checkbox"
                    class="custom-checkbox">
                <label class="fs-small" for="marketing">
                    Please keep me up-to-date with news and special offers
                </label>
            </div>
            <div class="mb-4 d-inline-block fs-6">
                <input [class.is-invalid]="form.controls.terms.invalid && form.controls.terms.touched" id="terms"
                    type="checkbox" class="custom-checkbox" formControlName="terms">
                <label class="fs-small" for="terms">
                    <span>I agree to the</span>
                    <a [routerLink]="'/terms-and-conditions'" [target]="'_blank'" class="link--terms ms-1">
                        terms &amp; conditions
                    </a>
                    <span class="text-danger text-28 mx-1 lh-1 ast-pos">*</span>
                </label>
                <div class="invalid-feedback">
                    Please accept terms & conditions
                </div>
            </div>
            <div class="d-flex">
                <button *ngIf="isBasketAuth" (click)="doSignIn()" class="btn btn-warning btn-wide me-3" type="button">
                    Already registered?
                </button>
                <button [disabled]="ngForm.submitted && form.invalid" type="submit" class="btn btn-wide btn-primary">
                    Create Account
                    <span *ngIf="(overlays$ | async).busyIndicator || this.userCreated"
                        class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                </button>
            </div>
        </form>
    </ng-container>
</section>